import type { AcademicLevelDto, CurriculumDto } from '@_/api-contracts/common.ts';
import type { CheckboxTreeNode, CheckboxTreeProps } from '@_/components';
import { useMemo } from 'react';
import { CheckboxTree } from '@_/components';

type NodeValue = CurriculumDto | AcademicLevelDto;

export interface CurriculumCheckboxTreeProps extends Pick<
  CheckboxTreeProps<NodeValue>,
  'disabled' | 'loading' | 'onChange' | 'value'
> {
  curricula: CurriculumDto[];
}

export function CurriculumCheckboxTree({ curricula, ...otherProps }: CurriculumCheckboxTreeProps) {
  const curriculumNodes = useMemo<Array<CheckboxTreeNode<NodeValue>>>(
    () =>
      curricula?.map<CheckboxTreeNode<NodeValue>>(curriculum => ({
        id: curriculum.id,
        value: curriculum,
        children: curriculum.academicLevels?.map(level => ({
          id: level.id,
          value: level
        }))
      })) || [],
    [curricula]
  );

  return (
    <CheckboxTree<NodeValue>
      {...otherProps}
      nodes={curriculumNodes}
      renderLabel={node => node.name}
    />
  );
}
